



































import {
    TalkJSConversationCustomData,
    TalkJSUserCustomData,
} from '~/services/CommunicationService';
import CompanyService from '~/services/CompanyService';
import { User } from '~/services/IdentityService';
import {
    ConversationSelectedEvent,
    Inbox,
    CustomData,
    SelectConversationEvent,
} from 'talkjs/types/talk.types';
import Avatar from '~/components/builders/Avatar.vue';
import { buildIDParam } from '~/utils/urlUtils';
import { isMobile } from '~/utils/windowUtils';
import { AxiosResponse } from 'axios';
import { OrganizationV2 } from '~/models';
import Vue from 'vue';

export default Vue.extend({
    name: 'Inbox',
    components: { Avatar },
    data() {
        return {
            otherUserAvatar: '' as string,
            inbox: null as Inbox | null,
            otherUserCompanyId: null as number | null,
            otherUserFullName: '',
            otherUserJobTitle: '',
            otherUserCompanyTitle: '',
            otherUserCompanyLogo: '',
            otherUserCompanyDescription: '',
            hasOtherUserData: false,
            showImage: true,
        };
    },
    computed: {
        firstLetterInOtherUserName(): string {
            return this.otherUserFullName[0] || '';
        },
        isMobile(): boolean {
            return isMobile();
        },
        chatWrapperStyle(): Record<string, string> {
            return {
                gridArea: this.showOtherUserCard ? '1 / 1 / 2 / 2' : '1 / 1 / 2 / 3',
                alignItems: this.showOtherUserCard ? 'flex-end' : 'center',
                padding: this.showOtherUserCard ? '30px 0 30px 30px' : '30px 0 80px 0',
            };
        },
        myIdentity(): User | null {
            return this.$store.getters['profileModule/getUser']();
        },
        fullName(): string {
            return this.myIdentity
                ? `${this.myIdentity.firstName} ${this.myIdentity.lastName}`
                : '';
        },
        showOtherUserCard(): boolean {
            return !this.isMobile && this.hasOtherUserData;
        },
    },
    methods: {
        async onConversationSelected(event: ConversationSelectedEvent) {
            let conversationData: Partial<TalkJSConversationCustomData>;
            if (event.conversation?.custom) {
                conversationData = event.conversation
                    ?.custom as Partial<TalkJSConversationCustomData>;
            } else {
                console.error('[Chat]: Conversation custom data is missing');
                return;
            }
            if (!conversationData.context_id) {
                console.error('[Chat]: Conversation context_id is missing');
                return;
            }
            if (!event.others) {
                console.error('[Chat]: Received event with no others from TalkJS');
                return;
            }
            let otherCustomData = event.others[0].custom as Partial<TalkJSUserCustomData>;
            this.hasOtherUserData = true;
            if (otherCustomData.isDummy) {
                console.warn('[Chat]: Conversation with dummy user was selected in TalkJS');
                return;
            } else {
                if (!otherCustomData) {
                    console.error('[Chat]: Other custom data is missing');
                    return;
                }
                this.otherUserJobTitle = this.getJobTitleByOrgId(
                    event.others[0].custom,
                    conversationData.context_id
                );
                let company: AxiosResponse<OrganizationV2>;
                if (conversationData.context_id) {
                    company = await CompanyService.getCompany(
                        parseInt(conversationData.context_id)
                    );
                    this.otherUserCompanyId = parseInt(conversationData.context_id);
                } else {
                    console.error('[Chat]: Context is is missing');
                    return;
                }
                this.otherUserAvatar = event.others[0].photoUrl || '';
                this.otherUserFullName = event.others[0].name || '';
                this.otherUserCompanyTitle = company.data.title || '';
                this.otherUserCompanyLogo = company.data.logo || '';
                this.showImage = true;
                this.otherUserCompanyDescription = company.data.description || '';
            }
        },
        async tryCreateAndMountInbox() {
            const chatService = this.$store.getters['talkSessionModule/getChatService']();
            if (!chatService) {
                return;
            }
            this.inbox = await chatService.tryCreateInbox(
                'communication-v2-inbox-as-inbox-student-ui',
                this.onConversationSelected
            );
            if (this.inbox) {
                await this.inbox.mount(this.$refs.talkjs as HTMLElement);
            }
            if (this.inbox?.currentConversation == null) {
                const unwatch = this.$store.watch(
                    () => this.$store.getters['talkSessionModule/getCurrentConversationId'](),
                    currentConversationId => {
                        this.inbox?.select(currentConversationId);
                        unwatch();
                    }
                );
            }
        },
        toCompanyProfile() {
            if (this.otherUserCompanyId) {
                const routeData = this.$router.resolve(
                    this.$URLS.findcompanies.concat(
                        '/',
                        buildIDParam(this.otherUserCompanyId.toString())
                    )
                );
                window.open(routeData.href, '');
            }
        },
        toProfile() {
            this.$router.push(this.$URLS.profile);
        },
        getJobTitleByOrgId(customData: CustomData, organizationId: string) {
            const propertyKey = `organizationJobTitle:${organizationId}`;
            return customData[propertyKey];
        },
        async onTalkJsUserChanged() {
            await this.tryCreateAndMountInbox();
        },
        handleImageError() {
            this.showImage = false;
        },
    },
    async created() {
        this.$store.watch(
            () => this.$store.getters['talkSessionModule/getMyTalkJsUser'](),
            () => this.onTalkJsUserChanged
        );
        this.$store.watch(
            () => this.$store.getters['talkSessionModule/getChatService'](),
            () => this.tryCreateAndMountInbox()
        );
        await this.tryCreateAndMountInbox();
    },
});
